export default "__VITE_ASSET__a29f904c__"